/* eslint-disable no-console */
/**
 * Lightweight browser/logger helper for the MVP build.
 *
 *  - `logger.debug` only logs during `pnpm dev` (`import.meta.env.DEV` is true).
 *  - `logger.info`, `warn`, and `error` always log.
 *
 * This avoids crashing DevTools with excessive logs in production while
 * preserving useful diagnostics during development.
 */

const isDev = import.meta.env.DEV; // Replaced by Vite at build-time

export const logger = {
  debug: (...a: unknown[]) => isDev && console.debug('[DEBUG]', ...a),
  info:  (...a: unknown[]) => console.info ('[INFO] ', ...a),
  warn:  (...a: unknown[]) => console.warn ('[WARN] ', ...a),
  error: (...a: unknown[]) => console.error('[ERR ] ', ...a),
} as const; 